import React from "react";
import withStyles from '@mui/styles/withStyles';
import Teaser from "./teaser";
import Contact from "./contact";
import useMakeScrollable from '../../custom_hooks/make-scrollable'
import backArrow from '../../assets/images/left_arrow.png';
import { useHistory } from "react-router-dom";

const styles = theme => ({
  root: {
    minHeight: 650,
    marginTop: 10,
    "&:last-child": {
      marginBottom: 150
    },
    "&:first-child": {
      marginTop: 0,
    }
  }
});


const Trainer = ({ trainers }) => {
  useMakeScrollable();
  const history = useHistory();
  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div style={{ backgroundColor: '#fff' }} className="scrollable">
      <img 
        src={backArrow} 
        alt="back" 
        className="points-header-arrow" 
        onClick={handleBack} 
        style={{ padding: 12 }}
      />
      {trainers.map(trainer => (
        <div
          name="TrainerWrapper"
          height="100%"
          className='trainer-container'
          data-testid="trainer"
          key={trainer.trainer.id}
        >
          <Teaser trainer={trainer} />
          <Contact trainer={trainer.trainer} />
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(Trainer);
